import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { getWishListCourcesByUser, removeCourseFromWishList, } from '../../../Constants/Api/functions/function';
import {
    HeartFilled,
    ShoppingCartOutlined,
    HeartOutlined,
    EyeOutlined,
} from '@ant-design/icons';
import { Spin, Empty, Badge } from 'antd';

import './styles.scss'
import { Link } from 'react-router-dom';



const WishList = () => {
    const [isLoading, setIsLoading] = useState(false);
    const userProfile = useSelector(state => state.userProfile.userProfile);
    const [wishlistCourses, setWishlistCourses] = useState([]);

    useEffect(() => {
        if (userProfile) {
            getCourseData(userProfile.id);
        }
    }, [])

    const getCourseData = async (userId) => {
        setIsLoading(true);
        try {
            const response = await getWishListCourcesByUser(userId);
            setWishlistCourses(response || []);
        } catch (error) {
            console.log(error);
        }

        setIsLoading(false);
    }

    const handleRemoveFromWishList = async (courseId) => {
        setIsLoading(true);
        try {
            const response = await removeCourseFromWishList(userProfile.id, courseId);
            if (response) {
                getCourseData(userProfile.id);
            }
        } catch (error) {
            console.log(error);
        }

        setIsLoading(false);
    }

    return (
        <div className='wishlist-page'>
            {/* Header */}
            <div className='wl-header'>
                <div className='wl-header-left'>
                    <div className='wl-header-icon'>
                        <HeartOutlined />
                    </div>
                    <div>
                        <h1 className='wl-title'>My Wish List</h1>
                        <p className='wl-subtitle'>
                            {wishlistCourses?.length || 0} course{wishlistCourses?.length !== 1 ? 's' : ''} saved
                        </p>
                    </div>
                </div>
            </div>

            <Spin spinning={isLoading} tip="Loading wishlist..." size="large">
                {wishlistCourses?.length === 0 && !isLoading ? (
                    <div className='wl-empty-state'>
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                                <span className='wl-empty-text'>
                                    Your wishlist is empty. Browse courses and add them here!
                                </span>
                            }
                        />
                    </div>
                ) : (
                    <div className='wl-grid'>
                        {wishlistCourses?.map((item, index) => (
                            <div
                                className='wl-card'
                                key={item.id}
                                style={{ animationDelay: `${index * 0.05}s` }}
                            >
                                {/* Image */}
                                <div className='wl-card-image'>
                                    <img
                                        src={item?.coverImage && item?.coverImage}
                                        alt={item?.name}
                                    />
                                    {/* Remove from wishlist */}
                                    <button
                                        className='wl-remove-btn'
                                        onClick={() => handleRemoveFromWishList(item.id)}
                                        title="Remove from wishlist"
                                    >
                                        <HeartFilled />
                                    </button>
                                    {/* Free badge */}
                                    {item?.price === 0 && (
                                        <span className='wl-free-badge'>FREE</span>
                                    )}
                                </div>

                                {/* Content */}
                                <div className='wl-card-content'>
                                    <h3 className='wl-card-title'>{item?.name}</h3>

                                    <div className='wl-card-meta'>
                                        {item?.price > 0 && (
                                            <span className='wl-price'>{item?.price} LKR</span>
                                        )}
                                    </div>
                                </div>

                                {/* Actions */}
                                <div className='wl-card-actions'>
                                    <Link
                                        to={`/dashboard/cources/${item.id}/buy`}
                                        className='wl-action-btn wl-action-primary'
                                    >
                                        <ShoppingCartOutlined />
                                        Buy Course
                                    </Link>
                                    {item?.isPublished && (
                                        <Link
                                            to={`/dashboard/cources/${item.id}`}
                                            className='wl-action-btn wl-action-secondary'
                                        >
                                            <EyeOutlined />
                                        </Link>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </Spin>
        </div>
    )
}

export default WishList